import { IApplicationState } from '../../types/redux';

export const getMapFullUrl = (state: IApplicationState) => {
  return state.offersData.mapFullUrl;
};
